import {
    postInvoiceProviderReset,
    postInvoiceProviderLoading,
    postInvoiceProviderSuccess,
    postInvoiceProviderReject,
    postInvoiceProviderRequest
} from "../../actions/invoiceProvider/post";

export const postInvoiceProvider = (formData) => async (dispatch, getState) => {
    dispatch(postInvoiceProviderLoading());
    try {
        const { data } = await postInvoiceProviderRequest(formData, getState);
        dispatch(postInvoiceProviderSuccess(data))
    } catch (error) {
        dispatch(postInvoiceProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(postInvoiceProviderReset()) }, 3000);
    }
    return Promise.resolve();
};